<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{ path: '/dashboard' }">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
		  &copy; {{ year }},
        <a href="#">{{ $dashcontroller }}</a>. <small>{{ $appver }}</small>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
	inject: ["$appver", "$dashcontroller"],
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
